module.exports = "/static/assets/2eafbafeeadf6ee799e6d04b4f21649b.png";